<script>
import Modal from '@/components/atoms/Modal'
import GroupOrderBlock from '@/components/organism/block/GroupOrderBlock'
import ButtonLoader from '@/components/atoms/ButtonLoader'

export default {
    name: 'ModalGroupOrder',
    components: {
        ButtonLoader,
        GroupOrderBlock,
        Modal,
    },
    data() {
        return {
            loading: false,
            backup: null,
        }
    },
    computed: {
        cart() {
            return this.$cart
        },
        canGroupOrder() {
            return this.$cart.calculated
                ? this.$cart.canStandardGroupOrder || this.$cart.canCanteenGroupOrder
                : false
        },
    },
    methods: {
        open() {
            this.$refs.ModalGroupOrder.openModal()
            this.$nextTick(() => {
                this.$refs.groupBlock.init()
            })
        },
        close() {
            this.$refs.ModalGroupOrder.closeModal()
            this.loading = false
        },
        error() {
            this.loading = false
        },
        async save() {
            if (this.$refs.groupBlock.selected) {
                this.$refs.groupBlock.attention()
            } else {
                this.loading = true
                await this.$refs.groupBlock.save()
                this.close()
            }
        },
        discard() {
            this.$refs.groupBlock?.discard()
        },
        unselect() {
            this.$refs.groupBlock?.reset()
            this.close()
        },
    },
}
</script>

<template lang="pug">
.group-order(v-if="canGroupOrder")
    button.btn.btn-dark(@click="open" :class="{'active': $cart.isGroupOrder}")
        icon(icon="fa-solid fa-user-friends")
        span {{$t('order.group_order')}}
    modal(ref="ModalGroupOrder" show @close="discard")
        template(v-slot:header)
            div
                .modal-header-text {{$t('order.group_order')}}
                span  {{$t('order.group_order_desc')}}
        template(v-slot:body)
            group-order-block(ref="groupBlock" @error="error")
        template(v-slot:footer)
            button.btn.btn-secondary(@click="unselect") {{$t('base.discard')}}
            button-loader.btn.btn-primary(@click="save" :loading="loading" inline) {{$t('order.save')}}
</template>
